import { Controller } from "@hotwired/stimulus"

export default class LandingHeader extends Controller {
  static targets = ["container", "mobileMenu"]

  connect() {
    this.isScrolled = false
    this.isMenuOpen = false
    this.handleScroll = this.handleScroll.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    window.addEventListener("keydown", this.handleKeydown)
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener("keydown", this.handleKeydown)
  }

  handleScroll() {
    const scrollY = window.scrollY
    const shouldBeScrolled = scrollY > 0

    if (shouldBeScrolled !== this.isScrolled) {
      this.isScrolled = shouldBeScrolled
      this.containerTarget.classList.toggle("-scrolled", shouldBeScrolled)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.isMenuOpen) {
      this.closeMenu()
    }
  }

  openMenu() {
    this.isMenuOpen = true
    this.mobileMenuTarget.classList.add("-open")
    document.body.style.overflow = "hidden"
  }

  closeMenu() {
    this.isMenuOpen = false
    this.mobileMenuTarget.classList.remove("-open")
    document.body.style.overflow = ""
  }

  smoothScroll(event) {
    const href = event.currentTarget.getAttribute("href")
    const hash = href.includes("#") ? href.split("#")[1] : null

    if (hash) {
      const target = document.getElementById(hash)
      if (target) {
        event.preventDefault()
        this.closeMenu()
        target.scrollIntoView({ behavior: "smooth" })
      }
    }
  }
}
